import { findRateOfDate } from '../../utils/find-rate-of-date.js'

/**
 *
 * @param {*} valueToConvert
 * @param {*} date
 * @param {Array<string>} pairCodes - eg. ['USD', 'EUR']
 * @param {*} ratesMap Should be a map of rates in format
 *  {from<XXX>:
 *    {to<XXX>:
 *      [{date: string, rate: number}] : with such array being sorted by date
 *    }
 *  }
 * }
 * @returns
 */
export function convert (valueToConvert, date, pairCodes, ratesMap) {
  // console.log('valueToConvert', valueToConvert)
  // console.log('date', date)
  // console.log('pairCodes', pairCodes)

  const valueToConvertNumber = parseFloat(valueToConvert)

  const conversionResult = {
    convertedValue: valueToConvertNumber,
    inputValue: valueToConvertNumber
  }
  // console.log('ratesMap', ratesMap)
  if (pairCodes[0] === pairCodes[1]) return conversionResult

  const pairRates = ratesMap?.get(pairCodes[0])?.get(pairCodes[1])
  if (!pairRates) return conversionResult

  const rate = findRateOfDate(pairRates, date)
  if (!rate) return conversionResult
  // console.log('rate', rate)

  conversionResult.convertedValue = valueToConvertNumber * rate.rate
  conversionResult.conversionRate = rate.rate
  conversionResult.rateDetails = rate

  return conversionResult
}
